import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from './Footer';

interface LegalLayoutProps {
    title: string;
    lastUpdated: string;
    children: React.ReactNode;
}

export default function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
    return (
        <div className="min-h-screen bg-dark-900">
            {/* Header */}
            <header className="bg-dark-800 border-b border-dark-700">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to Home
                    </Link>
                </div>
            </header>

            {/* Content */}
            <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="max-w-4xl mx-auto">
                    {/* Title Section */}
                    <div className="mb-8 pb-8 border-b border-dark-700">
                        <div className="flex items-center gap-3 mb-4">
                            <div className="relative">
                                <div className="absolute inset-1 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-lg blur-md opacity-50"></div>
                                <img src="/icon.png" alt="DareUp" className="relative w-10 h-10 rounded-lg" />
                            </div>
                            <span className="font-display text-xl font-bold text-gradient">DareUp</span>
                        </div>
                        <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mb-2">{title}</h1>
                        <p className="text-gray-400">Last Updated: {lastUpdated}</p>
                    </div>

                    {/* Legal Content */}
                    <div className="prose prose-invert prose-lg max-w-none">{children}</div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
